import React from 'react';
import SystemSubscriptionAck from "../containers/SystemSubscriptionAck/SystemSubscriptionAck";

const SystemSubscriptionAckPage: React.FC = () => {
	return (<SystemSubscriptionAck />);
};

export default SystemSubscriptionAckPage;
